import Vue from "vue";
import VueRouter from "vue-router";
import Signup from "../views/Signup.vue";
import Welcome from "../views/Welcome.vue";
import NotFound from "../views/404.vue";
import InvalidReffer from "../views/InvalidReferrer.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/start",
    name: "signup",
    component: Signup
  },
  {
    path: "/",
    name: "welcome",
    component: Welcome
  },
  {
    path: "/404",
    name: "notfound",
    component: NotFound
  },  // referrer domain exception
  {
    path: "/invalid",
    name: "invalid-referrer",
    component: InvalidReffer
  },
  // catch all 404 - define at the very end
  {
    path: "*",
    name: "notfound",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
